import React, { useEffect, useState } from 'react';
import { 
  Avatar, Tabs, Skeleton, Empty, Card, Row, Col, Tag, Badge, Tooltip, 
  Spin, Alert, Input, Space, Typography, Divider, Button, Modal, message
} from 'antd';
import { 
  ThunderboltOutlined, 
  WalletOutlined, 
  HistoryOutlined, 
  CustomerServiceOutlined,
  HomeOutlined,
  CreditCardOutlined,
  SafetyOutlined,
  AppstoreOutlined,
  SearchOutlined,
  ArrowLeftOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  SecurityScanOutlined,
  TrophyOutlined,
  StarOutlined,
  RightOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import CommonBillPayment from './commonBillPayment'; // Import CommonBillPayment instead
import { BBPS_CATEGORIES_CC } from './../../Utils/appConstants';
import { useHistory } from "react-router-dom";
import { getNewRequest } from '../../Utils/AppApi';
import './UtilityPayment.css';
import Complaint from './complaint';
import History from './history';

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;

function UitilityPayment(props) {
  const history = useHistory();
  const [tabName, setTabName] = useState('1');
  const [billerCategory, setBillerCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);

  const getBillerCategory = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await getNewRequest(BBPS_CATEGORIES_CC, history);
      console.log('Full Response:', response);
      
      let categories = null;
      
      if (response && response.data) {
        if (response.data.data && response.data.data.data) {
          categories = response.data.data.data;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          categories = response.data.data;
        }
      }
      
      if (categories && Array.isArray(categories) && categories.length > 0) {
        const modules = categories
          .filter(ele => ele.category_name && !/[^ a-zA-Z]/.test(ele.category_name))
          .map(ele => ({
            cat_id: ele.cat_id,
            category_name: ele.category_name,
            icon: ele.icon
          }));
        
        setBillerCategory(modules);
        message.success(`${modules.length} services loaded successfully`);
      } else {
        setBillerCategory([]);
        setError('No services available at the moment');
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      setError('Failed to load services. Please try again later.');
      setBillerCategory([]);
    } finally {
      setLoading(false);
    }
  };

  const onchangeTab = (key) => {
    setTabName(key);
    if (key !== '1') {
      setSelectCategory(null);
      setSelectedCategoryId(null);
    }
  };

  const handleService = (category, cat_id) => {
    setSelectCategory(category);
    setSelectedCategoryId(cat_id);
  };

  useEffect(() => {
    getBillerCategory();
  }, []);

  const getCategoryIcon = (categoryName) => {
    const name = categoryName.toUpperCase();
    if (name.includes('ELECTRICITY')) return <ThunderboltOutlined style={{ fontSize: '28px' }} />;
    if (name.includes('WATER')) return <i className="fas fa-tint" style={{ fontSize: '28px' }} />;
    if (name.includes('GAS') || name.includes('LPG')) return <i className="fas fa-fire" style={{ fontSize: '28px' }} />;
    if (name.includes('BROADBAND')) return <i className="fas fa-wifi" style={{ fontSize: '28px' }} />;
    if (name.includes('MOBILE') || name.includes('POSTPAID')) return <i className="fas fa-mobile-alt" style={{ fontSize: '28px' }} />;
    if (name.includes('FASTAG')) return <i className="fas fa-tag" style={{ fontSize: '28px' }} />;
    if (name.includes('INSURANCE')) return <SafetyOutlined style={{ fontSize: '28px' }} />;
    if (name.includes('CREDIT_CARD')) return <CreditCardOutlined style={{ fontSize: '28px' }} />;
    if (name.includes('LOAN') || name.includes('EMI')) return <WalletOutlined style={{ fontSize: '28px' }} />;
    return <HomeOutlined style={{ fontSize: '28px' }} />;
  };

  const getCategoryColor = (categoryName) => {
    const name = categoryName.toUpperCase();
    if (name.includes('ELECTRICITY')) return '#ff6b6b';
    if (name.includes('WATER')) return '#4dabf7';
    if (name.includes('GAS') || name.includes('LPG')) return '#ff922b';
    if (name.includes('BROADBAND')) return '#9775fa';
    if (name.includes('MOBILE')) return '#51cf66';
    if (name.includes('FASTAG')) return '#fcc419';
    if (name.includes('INSURANCE')) return '#339af0';
    if (name.includes('CREDIT_CARD')) return '#f06595';
    return '#868e96';
  };

  const filteredCategories = billerCategory.filter(category =>
    category.category_name.toLowerCase().replace(/_/g, ' ').includes(searchTerm.toLowerCase())
  );

  const getGroupedCategories = () => {
    const groups = {
      'Quick Recharge': ['PREPAID', 'FASTAG', 'DTH', 'METRO'],
      'Home Utilities': ['ELECTRICITY', 'WATER', 'BROADBAND', 'POSTPAID', 'LPG', 'GAS', 'CABLE'],
      'Financial Services': ['INSURANCE', 'LOAN', 'EMI', 'CREDIT_CARD', 'LIC', 'REPAYMENT', 'MUNICIPAL', 'CREDIT_CARD'],
      'Other Services': []
    };

    const categorized = {
      'Quick Recharge': [],
      'Home Utilities': [],
      'Financial Services': [],
      'Other Services': []
    };

    filteredCategories.forEach(category => {
      const categoryName = category.category_name.toUpperCase();
      let placed = false;

      for (const [group, keywords] of Object.entries(groups)) {
        if (keywords.some(keyword => categoryName.includes(keyword))) {
          categorized[group].push(category);
          placed = true;
          break;
        }
      }

      if (!placed) {
        categorized['Other Services'].push(category);
      }
    });

    return Object.entries(categorized).filter(([_, services]) => services.length > 0);
  };

  const categoryGroups = getGroupedCategories();

  // Stats cards data
  const statsData = [
    { number: billerCategory.length, label: 'Services', icon: <AppstoreOutlined />, color: '#667eea' },
    { number: '24/7', label: 'Support', icon: <CustomerServiceOutlined />, color: '#51cf66' },
    { number: '100%', label: 'Secure', icon: <SecurityScanOutlined />, color: '#ff6b6b' },
    { number: 'Instant', label: 'Payment', icon: <CheckCircleOutlined />, color: '#fcc419' },
  ];

  return (
    <div className="bbps-modern-container">
      {/* Animated Background */}
      <div className="bbps-animated-bg">
        <div className="bbps-bg-shape bbps-shape-1"></div>
        <div className="bbps-bg-shape bbps-shape-2"></div>
        <div className="bbps-bg-shape bbps-shape-3"></div>
      </div>

      <div className="content-wrapper pt-4">
        <div className="content">
          <div className="container-fluid">
            {/* Enhanced Hero Section */}
            <div className="bbps-modern-hero mb-4">
              <Row gutter={[24, 24]} align="middle">
                <Col xs={24} lg={14}>
                  <div className="bbps-hero-content">
                    <div className="bbps-hero-badge">
                      <TrophyOutlined /> India's Trusted Bill Payment Platform
                    </div>
                    <h1 className="bbps-hero-main-title">
                      Pay Bills & Recharges
                      <span className="bbps-gradient-text"> Instantly</span>
                    </h1>
                    <p className="bbps-hero-description">
                      Experience the fastest, most secure way to pay all your utility bills, 
                      recharge services, and manage payments - all in one place.
                    </p>
                    <Space size="middle" className="bbps-hero-features">
                      <span><CheckCircleOutlined /> 0% Commission</span>
                      <span><ClockCircleOutlined /> Instant Settlement</span>
                      <span><SecurityScanOutlined /> Bank Grade Security</span>
                    </Space>
                  </div>
                </Col>
                <Col xs={24} lg={10}>
                  <div className="bbps-stats-grid">
                    {statsData.map((stat, index) => (
                      <div key={index} className="bbps-stat-card-modern" style={{ borderColor: stat.color }}>
                        <div className="bbps-stat-icon" style={{ color: stat.color }}>
                          {stat.icon}
                        </div>
                        <div className="bbps-stat-number-modern">{stat.number}</div>
                        <div className="bbps-stat-label-modern">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </div>

            {/* Main Content Card */}
            <Row>
              <Col span={24}>
                <Card className="bbps-modern-card" bordered={false}>
                  {!selectCategory ? (
                    <>
                      {/* Enhanced Search Section */}
                      <div className="bbps-modern-search mb-5">
                        <div className="bbps-search-wrapper">
                          <SearchOutlined className="bbps-search-icon-modern" />
                          <input
                            type="text"
                            className="bbps-search-input-modern"
                            placeholder="Search for electricity, broadband, credit card, fastag or any bill..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          {searchTerm && (
                            <button 
                              className="bbps-search-clear"
                              onClick={() => setSearchTerm('')}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        {searchTerm && filteredCategories.length > 0 && (
                          <div className="bbps-search-results">
                            Found {filteredCategories.length} service(s)
                          </div>
                        )}
                      </div>

                      {/* Error State */}
                      {error && (
                        <Alert
                          message="Error"
                          description={error}
                          type="error"
                          showIcon
                          closable
                          className="mb-4"
                          action={
                            <Button size="small" onClick={getBillerCategory}>
                              Retry
                            </Button>
                          }
                        />
                      )}

                      {/* Modern Tabs */}
                      <Tabs
                        activeKey={tabName}
                        onChange={onchangeTab}
                        className="bbps-modern-tabs"
                        size="large"
                        tabBarExtraContent={
                          <div className="bbps-brand-logo-modern">
                            <img
                              className='bbps-brand-img'
                              onClick={() => setSelectCategory(false)}
                              src='../images/bharat_connect.png'
                              width="100"
                              alt='Bharat Connect'
                            />
                          </div>
                        }
                      >
                        <TabPane 
                          key="1" 
                          tab={
                            <span className="bbps-modern-tab-label">
                              <AppstoreOutlined /> All Services
                            </span>
                          }
                        >
                          {loading ? (
                            <div className="bbps-loading-container">
                              <Spin size="large" tip="Loading services..." />
                            </div>
                          ) : filteredCategories.length > 0 ? (
                            categoryGroups.map(([groupName, services]) => (
                              <div key={groupName} className="bbps-modern-group mb-5">
                                <div className="bbps-modern-group-header">
                                  <div className="bbps-group-icon-wrapper">
                                    {groupName === 'Quick Recharge' && <ThunderboltOutlined />}
                                    {groupName === 'Home Utilities' && <HomeOutlined />}
                                    {groupName === 'Financial Services' && <WalletOutlined />}
                                    {groupName === 'Other Services' && <StarOutlined />}
                                  </div>
                                  <h3 className="bbps-modern-group-title">{groupName}</h3>
                                  <div className="bbps-group-divider"></div>
                                  <span className="bbps-group-count">{services.length} services</span>
                                </div>
                                
                                <Row gutter={[20, 20]}>
                                  {services.map((category, index) => (
                                    <Col xs={12} sm={8} md={6} lg={4} xl={3} key={index}>
                                      <Tooltip title={`Click to pay ${category.category_name.replace(/_/g, ' ')} bill`} placement="bottom">
                                        <div 
                                          className="bbps-modern-service-card"
                                          onClick={() => handleService(category.category_name, category.cat_id)}
                                          style={{ '--card-color': getCategoryColor(category.category_name) }}
                                        >
                                          <div className="bbps-card-glow"></div>
                                          <div className="bbps-modern-service-icon" style={{ background: `${getCategoryColor(category.category_name)}15` }}>
                                            {category.icon ? (
                                              <img
                                                src={category.icon}
                                                alt={category.category_name}
                                                className="bbps-service-icon-img-modern"
                                              />
                                            ) : (
                                              <div className="bbps-icon-wrapper" style={{ color: getCategoryColor(category.category_name) }}>
                                                {getCategoryIcon(category.category_name)}
                                              </div>
                                            )}
                                          </div>
                                          <h5 className="bbps-modern-service-name">
                                            {category.category_name.replace(/_/g, ' ')}
                                          </h5>
                                          <div className="bbps-modern-service-tag">
                                            Pay Now <RightOutlined />
                                          </div>
                                          <div className="bbps-card-hover-effect"></div>
                                        </div>
                                      </Tooltip>
                                    </Col>
                                  ))}
                                </Row>
                              </div>
                            ))
                          ) : (
                            <Empty 
                              description={!loading ? "No services found matching your search" : "Loading services..."}
                              image={Empty.PRESENTED_IMAGE_SIMPLE}
                            >
                              {searchTerm && (
                                <Button onClick={() => setSearchTerm('')} type="primary">
                                  Clear Search
                                </Button>
                              )}
                            </Empty>
                          )}
                        </TabPane>

                        <TabPane 
                          key="2" 
                          tab={
                            <span className="bbps-modern-tab-label">
                              <HistoryOutlined /> Transaction History
                            </span>
                          }
                        >
                          <History />
                        </TabPane>

                        <TabPane 
                          key="3" 
                          tab={
                            <span className="bbps-modern-tab-label">
                              <CustomerServiceOutlined /> Support Center
                            </span>
                          }
                        >
                          <Complaint />
                        </TabPane>
                      </Tabs>
                    </>
                  ) : (
                    <div className="bbps-modern-payment-section">
                      <Button 
                        className="bbps-modern-back-btn"
                        onClick={() => {
                          setSelectCategory(null);
                          setSelectedCategoryId(null);
                        }}
                        icon={<ArrowLeftOutlined />}
                      >
                        Back to All Services
                      </Button>
                      {/* Use CommonBillPayment instead of ElectricityBillPayment */}
                      <CommonBillPayment 
                        category={selectCategory} 
                        categoryId={selectedCategoryId}
                      />
                    </div>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UitilityPayment;